import { render, staticRenderFns } from "./ForumResponseBodyFooter.vue?vue&type=template&id=e19ad01c&scoped=true"
import script from "./ForumResponseBodyFooter.vue?vue&type=script&lang=js"
export * from "./ForumResponseBodyFooter.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseBodyFooter.vue?vue&type=style&index=0&id=e19ad01c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19ad01c",
  null
  
)

export default component.exports